export const isSameDay = (dateA: Date, dateB: Date) => {
  return dateA.toDateString() === dateB.toDateString();
};
